// test798
(798 && 0);
